import { useNavigate } from "react-router-dom";
import Button, { ButtonType } from "../../components/Button/Button";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import Modal from "../../components/Modal/Modal";
import { Container, Wrapper } from "../../components/styled/styled-components";
import { useOrderUploaderContext } from "./context/OrderUploaderContext";

export type OrderUploadResult =
  | "progressBar"
  | "progressBarLevel"
  | "addingToCart"
  | "goToCart"
  | "clearCart";

const ModalSwitcher = () => {
  const {
    modalToShow,
    setModalToShow,
    handleClearCart: clearCart,
    isLoading,
    progressBarLevel,
  } = useOrderUploaderContext();
  const navigate = useNavigate();
  return (
    <>
      {modalToShow === "progressBar" && (
        <Modal>
          <div className="modalContent">
            <p>Please wait while we import your order</p>

            <div className="loadingSpinnerWrapper">
              <LoadingSpinner block />
            </div>
          </div>
        </Modal>
      )}

      {modalToShow === "progressBarLevel" && (
        <Modal>
          <div className="modalContent">
            <p>Please wait while we import your order</p>
            <p>
              Loaded {progressBarLevel.level} out of {progressBarLevel.totalItems} items
            </p>
            <div className="loadingSpinnerWrapper">
              <LoadingSpinner block />
            </div>
            <div className="progress">
              <div
                className="progress-bar progress-bar-striped bg-info"
                role="progressbar"
                style={{
                  width: `${
                    progressBarLevel.totalItems > 0
                      ? (progressBarLevel.level / progressBarLevel.totalItems) * 100
                      : 0
                  }%`,
                }}
                aria-valuenow={progressBarLevel.level}
                aria-valuemin={0}
                aria-valuemax={progressBarLevel.totalItems}
              />
            </div>
          </div>
        </Modal>
      )}

      {modalToShow === "addingToCart" && (
        <Modal>
          <div className="modalContent">
            <p>Please wait while we add your items to your cart</p>
            <div className="loadingSpinnerWrapper">
              <LoadingSpinner block />
            </div>
          </div>
        </Modal>
      )}

      {modalToShow === "goToCart" && (
        <Modal>
          <div className="modalContent">
            <p>Items added to cart.</p>
            <Wrapper>
              <Button onClick={() => navigate("/store/cart")} type={ButtonType.primary}>
                View Cart
              </Button>
            </Wrapper>
          </div>
        </Modal>
      )}

      {modalToShow === "clearCart" && (
        <Modal>
          <div className="modalContent">
            {isLoading ? (
              <>
                <p>Removing items from cart</p>
                <Wrapper>
                  <LoadingSpinner block />
                </Wrapper>
              </>
            ) : (
              <>
                <p>You have items in your current cart.</p>
                <p>Please clear your current cart to add these ones.</p>
                <Container>
                  <Button
                    onClick={() => clearCart()}
                    style={{ margin: "1em 0" }}
                    type={ButtonType.primary}
                  >
                    Clear cart
                  </Button>
                  <Button onClick={() => setModalToShow(null)} type={ButtonType.secondary}>
                    Cancel
                  </Button>
                </Container>
              </>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default ModalSwitcher;
